module.exports = __webpack_public_path__ + "fonts/CalibreSemibold.0cf4497b.woff";